<template>
    <v-dialog v-model="dialog" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <span class="headline">{{ esEdicion ? 'Editar pregunta' : 'Nueva pregunta' }}</span>
            </v-card-title>
            <v-card-text>
                <v-text-field v-model="form.label" label="Pregunta" required />

                <v-select
                    v-model="form.type"
                    :items="tipos"
                    label="Tipo de respuesta"
                    required
                />

                <div v-if="requiereOpciones">
                    <div v-for="(opcion, idx) in form.options" :key="idx" class="d-flex align-center">
                        <v-text-field v-model="form.options[idx]" :label="`Opción ${idx + 1}`" />
                        <v-icon class="ml-2" @click="quitarOpcion(idx)">delete</v-icon>
                    </div>
                    <v-btn small text color="primary" @click="agregarOpcion">
                        <v-icon left small>add</v-icon> Agregar opción
                    </v-btn>
                </div>

                <v-checkbox v-model="form.required" label="Obligatoria" />

                <v-alert v-if="error" type="error" outlined class="mt-3">{{ error }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cerrar">Cancelar</v-btn>
                <v-btn color="primary" :loading="guardando" @click="guardar">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import camposCustomApi from '../../../../../api/camposCustom';

export default {
    name: 'PreguntaDialog',
    props: {
        eventoId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            dialog: false,
            guardando: false,
            error: null,
            campoCustomId: null,
            form: {
                label: '',
                type: 'texto',
                options: [''],
                required: false,
            },
            tipos: [
                { text: 'Texto', value: 'texto' },
                { text: 'Selección única', value: 'seleccion_unica' },
                { text: 'Selección múltiple', value: 'seleccion_multiple' },
            ],
        };
    },
    computed: {
        esEdicion() {
            return this.campoCustomId !== null;
        },
        requiereOpciones() {
            return this.form.type === 'seleccion_unica' || this.form.type === 'seleccion_multiple';
        },
    },
    methods: {
        abrirNueva() {
            this.campoCustomId = null;
            this.form = { label: '', type: 'texto', options: [''], required: false };
            this.error = null;
            this.dialog = true;
        },
        abrirEdicion(pregunta) {
            this.campoCustomId = pregunta.id;
            this.form = {
                label: pregunta.label,
                type: pregunta.type,
                options: pregunta.options && pregunta.options.length ? [...pregunta.options] : [''],
                required: !!pregunta.required,
            };
            this.error = null;
            this.dialog = true;
        },
        cerrar() {
            this.dialog = false;
        },
        agregarOpcion() {
            this.form.options.push('');
        },
        quitarOpcion(idx) {
            this.form.options.splice(idx, 1);
        },
        guardar() {
            this.error = null;

            const payload = {
                label: this.form.label,
                type: this.form.type,
                required: this.form.required,
                options: this.requiereOpciones
                    ? this.form.options.map((o) => (o || '').trim()).filter((o) => o.length > 0)
                    : [],
            };

            if (!payload.label || !payload.type) {
                this.error = 'La pregunta y el tipo son obligatorios';
                return;
            }

            if (this.requiereOpciones && payload.options.length === 0) {
                this.error = 'Agregá al menos una opción';
                return;
            }

            this.guardando = true;
            const promesa = this.esEdicion
                ? camposCustomApi.update(this.campoCustomId, payload)
                : camposCustomApi.create(this.eventoId, payload);

            promesa
                .then(() => {
                    this.guardando = false;
                    this.dialog = false;
                    this.$emit('guardado');
                })
                .catch((err) => {
                    this.guardando = false;
                    this.error = (err && err.response && err.response.data && err.response.data.message)
                        || 'Ocurrió un error al guardar la pregunta';
                });
        },
    },
};
</script>
